export default "__VITE_ASSET__DucovtZu__"